import React from "react";
import logo from "../images/logo.png"
import { Link } from "react-router-dom";

export default function Title(){
    return(
        <div className="title-container">
            <Link to={"/"}><img src={logo} alt="colorantí logo" className="title-logo"/></Link>
            <div className="a">
                <h1 className="home-title">COLORANTÍ</h1>
                <div style={{display: "flex"}}>
                    <p className="slogan" style={{color: "gold"}}>MORALLY CODED</p> <p className="slogan"> | </p> <p className="slogan" style={{color: 'green'}}> TECHNICALLY SOUND</p>
                </div>
            </div>
        </div>
    )
}